<template>
  <el-select
    v-model="selectedValue"
    class="current-select"
    filterable
    remote
    clearable
    :remote-method="handleRemote"
    :placeholder="$t('CargoMsg.Cargo_PleaseSelect')"
    @change="changeHandle"
  >
    <el-option
      v-for="item in options"
      :key="item.uuid"
      :label="item.code + item.city"
      :value="item.uuid"
    />
  </el-select>
</template>

<script>
import { getPostalCodeList } from '@/api/basicData/postalCode'

export default {
  name: 'CargoPostCodeSelect',
  props: {
    defaultValue: { type: String, default: '' }
  },
  data() {
    return {
      selectedValue: '',
      options: [], // 存储选项数据
      currentPage: 0, // 当前页
      pageSize: 50, // 每页加载数量
      queryKey: ''
    }
  },
  watch: {
    defaultValue: {
      async handler(newVal) {
        if (newVal) {
          // 如果options中没有当前值，则重新加载数据
          if (!this.options.find(item => item.uuid === newVal)) {
            await this.handleRemote('', true)
          }
          this.selectedValue = newVal
        } else {
          this.selectedValue = ''
        }
      }
    }
  },
  mounted() {
    setTimeout(async() => {
      const dom = document.querySelector('.current-select>.el-select-dropdown>.el-scrollbar>.el-select-dropdown__wrap')
      dom.addEventListener('scroll', this.scroll)
      await this.handleRemote('', true)
      this.selectedValue = this.defaultValue
    })
  },
  methods: {
    // 处理远程查询
    async handleRemote(queryKey = '', first = false) {
      const originQueryKey = this.queryKey
      this.queryKey = queryKey
      if (originQueryKey !== this.queryKey) {
        this.currentPage = 0
        this.pageSize = 50
      }
      const currentPage = ++this.currentPage
      // 假设从接口获取的数据
      let newOptions = await getPostalCodeList({
        code: this.queryKey,
        pageNum: currentPage,
        pageSize: this.pageSize,
        // uuid: first ? this.defaultValue : ''
        uuid: this.defaultValue
      }).then(res => res.data.list)
      if (originQueryKey !== this.queryKey) {
        this.options = newOptions
      } else {
        if (newOptions && newOptions.length > 0) {
          // 非第一次查询，将传进来的默认值从这次查询结果中排除，避免下拉重复
          if (this.defaultValue) {
            const row = this.options.find(p => p.uuid === this.defaultValue)
            if (row) {
              newOptions = newOptions.filter(p => p.uuid !== this.defaultValue)
            }
          }
          if (newOptions && newOptions.length > 0) {
            this.options = [...this.options, ...newOptions]
          }
        }
      }
    },
    scroll(event) {
      const domTarget = event.target
      const translateY = domTarget.scrollTop
      const viewHeight = domTarget.clientHeight
      const allHeight = domTarget.scrollHeight
      if (allHeight - translateY <= viewHeight + 5) {
        this.handleRemote(this.queryKey)
      }
    },
    async changeHandle() {
      if (this.selectedValue) {
        const row = this.options.find(p => p.uuid === this.selectedValue)
        this.$emit('change', row)
      } else {
        await this.handleRemote('')
        this.$emit('change')
      }
    }
  }
}
</script>

<style scoped>
/* 根据需求调整样式 */
</style>
